module.exports = __webpack_public_path__ + "img/filter.12194ed3.png";